import { type FC } from "react";
import { Table } from "@root/shared/components/Table/legacy/Table";
import { FullWidthTableRow } from "./uiParts/fullWidthTableRow";
import * as styles from "./styles.css";

export type thoughtsAndSelfPrProps = {
  reasonForApply?: string;
  importantPoint?: string;
  futurePlan?: string;
  selfPr?: string;
};

type Props = {
  thoughtsAndSelfPr: thoughtsAndSelfPrProps;
  showReadMoreButton?: boolean;
  maxDisplayLargeTextHeight?: number;
};

export const ThoughtsAndSelfPrTable: FC<Props> = ({
  thoughtsAndSelfPr: { reasonForApply, importantPoint, futurePlan, selfPr },
  showReadMoreButton = false,
  maxDisplayLargeTextHeight = 0,
}) => (
  <Table className={styles.tableContainer}>
    {reasonForApply && (
      <FullWidthTableRow
        thContent="なぜこの業界で働こうと思いましたか？"
        tdContent={reasonForApply}
        showReadMoreButton={showReadMoreButton}
        maxDisplayLargeTextHeight={maxDisplayLargeTextHeight}
      />
    )}
    {importantPoint && (
      <FullWidthTableRow
        thContent="お仕事をする上で大切にしていることは？"
        tdContent={importantPoint}
        showReadMoreButton={showReadMoreButton}
        maxDisplayLargeTextHeight={maxDisplayLargeTextHeight}
      />
    )}
    {futurePlan && (
      <FullWidthTableRow
        thContent="この先仕事でやってみたいことやキャリアプラン、将来の夢は？"
        tdContent={futurePlan}
        showReadMoreButton={showReadMoreButton}
        maxDisplayLargeTextHeight={maxDisplayLargeTextHeight}
      />
    )}
    {selfPr && (
      <FullWidthTableRow
        thContent="自己PR"
        tdContent={selfPr}
        showReadMoreButton={showReadMoreButton}
        maxDisplayLargeTextHeight={maxDisplayLargeTextHeight}
      />
    )}
  </Table>
);
